export const splitName = (input: string, delimiter: string) => {
  const name = input.trim();
  if (name === '') {
    return ['', ''];
  }

  if (name.split(' ').length > 1) {
    const index = name.indexOf(delimiter);
    return [name.substring(0, index), name.substring(index + 1)];
  }
  return [name, ''];
};
